import { formatDistance } from 'date-fns'
import { useEffect, useMemo, useState } from 'react'

export function useTimeBetweenText(date0: Date, date1: Date | undefined): string | undefined
export function useTimeBetweenText(date: Date, interval: number): string | undefined
export function useTimeBetweenText(date: Date): string | undefined
export function useTimeBetweenText(date0: Date, date1OrInterval?: Date | number): string | undefined {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    if (date1OrInterval instanceof Date) return

    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, date1OrInterval ?? 1000)

    return () => clearInterval(interval)
  }, [date1OrInterval])

  return useMemo(() => {
    return formatDistance(date0, date1OrInterval instanceof Date ? date1OrInterval : currentTime, { addSuffix: true })
  }, [date0, date1OrInterval, currentTime])
}

export default useTimeBetweenText
